/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'fleet-settings-tab-label',
    templateUrl: './settings-tab-label.component.html',
    styleUrls: ['./settings-tab-label.component.scss'],
    standalone: false
})
export class SettingsTabLabelComponent implements OnInit {
  @Input() showDescription = true;
  // @Input() selectedPanel: any;
  @Input() panel: any;

  @Output() tabClicked = new EventEmitter<void>();

  constructor() {}

  ngOnInit(): void {}
}
